import { render, staticRenderFns } from "./NpaStatistics.vue?vue&type=template&id=875004da"
import script from "./NpaStatistics.vue?vue&type=script&lang=js"
export * from "./NpaStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports